/* istanbul ignore file: These really need no tests */
export const emptyObject = Object.freeze({});
export const emptyArray = Object.freeze([]);
export const noop = () => {};
